import { TARGET_COLORS, TargetKey } from './dashboardTargetsUtils';

const randomInRange = (min: number, max: number) => {
  return Math.random() * (max - min) + min;
};

type FireworksOptions = {
  durationMs?: number;
  zIndex?: number;
};

const launchFireworksBurst = async (colors: string[], options?: FireworksOptions) => {
  if (colors.length === 0) return;

  const confettiModule = await import('canvas-confetti');
  const confetti = confettiModule.default;

  const duration = options?.durationMs ?? 5 * 1000;
  const animationEnd = Date.now() + duration;
  const defaults = {
    startVelocity: 30,
    spread: 360,
    ticks: 60,
    zIndex: options?.zIndex ?? 0,
    colors,
  };

  const interval = window.setInterval(() => {
    const timeLeft = animationEnd - Date.now();

    if (timeLeft <= 0) {
      window.clearInterval(interval);
      return;
    }

    const particleCount = 50 * (timeLeft / duration);
    confetti({
      ...defaults,
      particleCount,
      origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 },
    });
    confetti({
      ...defaults,
      particleCount,
      origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 },
    });
  }, 250);
};

export const launchTargetConfetti = async (targetKey: TargetKey) => {
  await launchFireworksBurst([TARGET_COLORS[targetKey]]);
};

export const launchCombinedConfetti = async (targetKeys: TargetKey[], options?: FireworksOptions) => {
  const colors = targetKeys.map((targetKey) => TARGET_COLORS[targetKey]);
  await launchFireworksBurst(colors, options);
};
